// register global Modal helper
window.Modal = {
    open: function (modal, data = {}) {
        Livewire.dispatch('openModal', {modal: modal, data: data})
    },
    close: function (id) {
        document.querySelector('[data-modal-id="' + id + '"]').classList.add('fade');
        Livewire.dispatch('closeModal', {id: id});
    },
}

// close top modal using Esc key
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        const modalManager = document.getElementById('modal-manager');
        const modals = modalManager.querySelectorAll('.modal');
        const lastModal = modals[modals.length - 1];
        Modal.close(lastModal.getAttribute('data-modal-id'));
    }
});

// triggering media modals
document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-media-modal-trigger]');
    if (!trigger) {
        return;
    }
    const data = {
        parentId: trigger.getAttribute('id')
    };
    const fileId = trigger.getAttribute('data-media-modal-trigger');
    if (fileId) {
        data.file = fileId;
    }

    Modal.open('file::components.media-modal', data);
});

document.addEventListener('livewire:init', () => {

    // clickable table rows
    document.addEventListener('click', (event) => {
        const table = event.target.closest('.table');
        if (!table) return;

        if (
            event.target.closest('button') ||
            event.target.closest('a') ||
            event.target.closest('input')
        ) {
            return;
        }

        const tr = event.target.closest('tr');
        if (!tr) return;
        const button = tr.querySelector('.clickable-target');
        if (button) button.click();
    });

});

window.addEventListener('popstate', function () {
    const url = new URL(window.location);
    const tabId = url.searchParams.get('tab');

    if (tabId) {
        const triggerEl = document.querySelector(`[data-bs-target="#tab-${tabId}"]`);
        if (triggerEl) {
            new bootstrap.Tab(triggerEl).show();
            return;
        }
    }

    // fallback: tab domyślny
    const defaultTab = document.querySelector('[data-tab-default]');
    if (defaultTab) {
        new bootstrap.Tab(defaultTab).show();
    }
});

window.copyToClipboard = async function (textToCopy) {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
        toastr['success']('Skopiowano do schowka.', null, {
            positionClass: 'toast-bottom-right',
            progressBar: true,
            timeOut: 3000
        });
    } else {
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";
        document.body.prepend(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            toastr['success']('Skopiowano do schowka.', null, {
                positionClass: 'toast-bottom-right',
                progressBar: true,
                timeOut: 3000
            });
        } catch (error) {
            toastr['error'](error, null, {
                positionClass: 'toast-bottom-right',
                progressBar: true,
                timeOut: 3000
            });
        } finally {
            textArea.remove();
        }
    }
}

window.setQueryParam = function(key, value) {
    const url = new URL(window.location);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url);
}

window.initTooltips = function (target = document) {
    target.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        const instance = bootstrap.Tooltip.getInstance(el);
        if (instance) {
            try { instance.hide();} catch (e) {}
            try { instance.dispose();} catch (e) {}
        }
        new bootstrap.Tooltip(el);
    });
}

window.closeTooltips = function () {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
        const instance = bootstrap.Tooltip.getInstance(el);
        if (instance) {
            try { instance.hide(); } catch (e) {}
        }
    });
}

document.addEventListener('livewire:init', () => {
    Livewire.hook('morphed', ({ el }) => {
        window.closeTooltips();
        window.initTooltips(el);
    });
    document.addEventListener('livewire:navigated', () => {
        window.closeTooltips();
        window.initTooltips();
    });
});
